import * as React from 'react';
export const navigationRef = React.createRef();

export function navigate(name, params) {
  navigationRef.current?.navigate(name, params);
}

// Function to go back in the navigation stack
export function goBack() {
  navigationRef.current?.goBack();
}

// Function to get the current route name
export function getCurrentRoute() {
  const rootState = navigationRef.current?.getRootState();
  
  if (!rootState) {
    return null;
  }
  
  // Start with the root routes
  let route = rootState.routes[rootState.index];

  // Loop through nested routes (if any)
  while (route.state && route.state.index !== undefined) {
    route = route.state.routes[route.state.index];
  }

  // The focused route name is the last one in the loop
  return route.name;
}
